import { useMemo } from 'react'
import { getTimeDifference } from './utils'
import { TimeDifference } from './types'

export const useTimeDifference = (timestamp: string): TimeDifference | undefined =>
  useMemo(() => getTimeDifference(timestamp), [timestamp])
